<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.quesData"
    :search="search"
    sort-by="rowId"
    class="elevation-1"
  >
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-select
              v-model="selectQ"
              :items="$store.state.questCmb"
              item-text="name"
              label="Select"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <v-text-field
              v-model="queryCon"
              v-bind:label="selectQ.placeholder"
              single-line
              hide-details
            ></v-text-field>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-select
              v-model="selectP"
              :items="$store.state.publicType"
              item-text="name"
              label="Select"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-2">
            <v-dialog
              ref="dialogQuery"
              v-model="modalQuery"
              :return-value.sync="datesQuery"
              persistent
              width="290px"
            >
              <!-- 手動輸入日期 -->
              <div class="pa-2" style="background-color: #fff">
                <v-text-field
                  label="填寫日期"
                  prepend-icon="event"
                  v-model="dateRangeTextInputQuery"
                  :placeholder="dateRangeTextQuery"
                  @keyup="textInputDateQuery"
                  @click="getDateRangQuery"
                ></v-text-field>
              </div>
              <template v-slot:activator="{ on }">
                <v-text-field
                  slot-scope
                  v-model="dateRangeTextQuery"
                  label="問卷填寫時間"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="datesQuery"
                locale="zh-tw"
                selected-items-text="已選擇兩個日期"
                range
                @change="clearTextInput"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalQuery = false">Cancel</v-btn>
                <!-- <v-btn text color="primary" @click="$refs.dialogQuery.save(datesQuery)">OK</v-btn> -->
                <v-btn text color="primary" @click="saveDates(datesQuery)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query(true)"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="editedItem.questSysId"
                            label="問卷編號"
                            :disabled="disabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.questTitle"
                            label="問卷名稱"
                            :disabled="disabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.isVisible"
                            :items="$store.state.publicType"
                            item-text="name"
                            item-value="value"
                            label="Select"
                            persistent-hint
                            return-object
                            single-line
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="7" md="7">
                          <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="dates"
                            persistent
                            width="290px"
                          >
                            <!-- 手動輸入日期 -->
                            <div class="pa-2" style="background-color: #fff">
                              <v-text-field
                                label="填寫日期"
                                prepend-icon="event"
                                v-model="dateRangeTextInput"
                                :placeholder="dateRangeText"
                                @keyup="textInputDate"
                                @click="getDateRang"
                              ></v-text-field>
                            </div>
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                slot-scope
                                v-model="dateRangeText"
                                @change="dateRangeOnChange"
                                label="問卷填寫時間"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dates"
                              locale="zh-tw"
                              selected-items-text="已選擇兩個日期"
                              range
                              @change="clearTextInput"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modal = false"
                                >取消</v-btn
                              >
                              <!-- <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(dates)"
                                >確認</v-btn
                              > -->
                              <v-btn text color="primary" @click="saveDates(dates)"
                                >確認</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="number"
                            v-model="editedItem.questMaxNum"
                            label="份數上限"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch
                            v-model="editedItem.isCooper"
                            label="同公司協作"
                            hide-details
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" text @click="validate" :disabled="!valid"
                    >儲存</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-slot:item.actions="{ item }"> -->
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="primary"
        @click="editItem(item)"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
export default {
  mounted() {
    this.$store.state.quesData = []
  },
  created() {
    this.initialize()
    this.$store.commit('getDate')
    this.datesQuery[0] = this.$store.state.date.current
    this.datesQuery[1] = this.$store.state.date.nextMonth
    this.query(false)
  },
  data() {
    return {
      valid: true,
      search: '',
      queryCon: '',
      dialog: false,
      disabled: false,
      selectQ: { name: '請選擇', value: null, placeholder: '' },
      selectP: { name: '請選擇', value: null },
      select: { name: '請選擇', value: '' },
      PublicType: ['公開問卷', '僅限會員', '僅限連結'],
      headers: [
        //{ text: '', value: 'rowId', sortable: false },
        { text: '問卷編號', value: 'questSysId' },
        { text: '問卷名稱', value: 'questTitle' },
        { text: '公開狀態', value: 'isVisible.name' },
        { text: '起始日期', value: 'questDateStart' },
        { text: '結束日期', value: 'questDateEnd' },
        { text: '份數上限', value: 'questMaxNum' },
        { text: '建立人員', value: 'creatUserName' },
        { text: '建立時間', value: 'creatTime' },
        { text: '異動人員', value: 'actUserName' },
        { text: '異動時間', value: 'actTime' },

        { text: '', value: 'actions', sortable: false },
      ],
      userData: [],
      publicType: ['01', '00'],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        quesId: '',
        quesName: '',
        publicType: '',
        startTime: '',
        endTime: '',
        limit: '',
        creatUser: '展小輝',
        creatTime: '2020-04-01',
        actUser: '',
        //actTime: '2020-04-01'
      },
      //日期 查詢條件
      datesQuery: ['', ''],
      dateRangeTextInputQuery: '',
      menuQuery: false,
      modalQuery: false,
      menu2Query: false,
      //日期 編輯資料
      dates: [],
      dateRangeTextInput: '',
      menu: false,
      modal: false,
      menu2: false,
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? '問卷維護' : '問卷維護'
    },
    dateRangeText() {
      if (
        this.dates.length === 2 &&
        Date.parse(this.dates[0]) > Date.parse(this.dates[1])
      ) {
        this.swapDate()
      }
      return this.dates.join(' ~ ')
    },
    dateRangeTextQuery() {
      if (
        this.datesQuery.length === 2 &&
        Date.parse(this.datesQuery[0]) > Date.parse(this.datesQuery[1])
      ) {
        this.swapDateQuery()
      }
      return this.datesQuery.join(' ~ ')
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  methods: {
    initialize() {},

    editItem(item) {
      this.dates = [item.questDateStart, item.questDateEnd]
      this.disabled = true
      this.editedIndex = this.$store.state.quesData.indexOf(item)

      this.editedItem = Object.assign({}, item)
      //this.$store.state.users = Object.assign({}, item)
      this.dialog = true
    },

    close() {
      this.disabled = false
      this.dialog = false
      setTimeout(() => {
        //this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validate() {
      this.$refs.form.validate()
      const str = this.dateRangeText.replace(/\s/g, '')
      const words = str.split('~')
      if (this.editedItem.isVisible.value === '-1') {
        alert('請選擇問卷公開狀態')
        return
      }
      if (words[0] == undefined || words[1] == undefined) {
        alert('請確認時間範圍正確')
        return
      }

      window.console.log(this.editedItem.questNowNum)
      window.console.log(this.editedItem.questMaxNum)
      if (parseInt(this.editedItem.questMaxNum) < parseInt(this.editedItem.questNowNum)) {
        alert('限定份數不得小於目前回覆數量')
        return
      }
      if (this.editedItem.questMaxNum < 1 && this.editedItem.questMaxNum != '') {
        alert('回覆數量需大於0')
        return
      }
      let url = this.$store.state.api + '/Q01020/ActQuestSet'
      let data = Object.assign(
        { questSysId: this.editedItem.questSysId },
        { questTitle: this.editedItem.questTitle },
        { questMaxNum: this.editedItem.questMaxNum },
        { isVisible: this.editedItem.isVisible.value },
        { isCooper: this.editedItem.isCooper },
        { strDate: words[0] },
        { endDate: words[1] }
      )
      window.console.log(data)
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        if (res.data.resultCode == '10') {
          window.console.log(res.data)
          if (res.data.reverseDate == '01') {
            const tmpDate = words[0]
            words[0] = words[1]
            words[1] = tmpDate
          }
          if (this.editedIndex > -1) {
            this.editedItem.questDateStart = words[0]
            this.editedItem.questDateEnd = words[1]
            this.editedItem.actUserName = res.data.actUserName
            this.editedItem.actTime = res.data.actTime

            Object.assign(this.$store.state.quesData[this.editedIndex], this.editedItem)
            this.close()
          } else {
            this.$store.state.quesData.push(this.editedItem)
            this.close()
          }
        } else {
          alert(res.data.error)
          this.close()
        }
      })
    },
    async query(isDate) {
      //分割日期字串
      const str = this.dateRangeTextQuery.replace(/\s/g, '')
      const words = str.split('~')

      let url = this.$store.state.api + '/Q01005/query'
      let data = Object.assign(
        { queryType: this.selectQ },
        { queryCon: this.queryCon },
        { publicType: this.selectP },
        { strDate: isDate === true ? words[0] : '' },
        { endDate: isDate === true ? words[1] : '' }
      )
      try {
        let res = await this.axios.post(url, this.qs.stringify(data))
        switch (res.data.resultCode) {
          case '10':
            res.data.rows.forEach((row) => {
              row.questQRCod = row.questUrl =
                this.$store.state.server + 'user/answer?questSysId=' + row.questSysId
              row.isVisible = {
                name: row.isVisible === '01' ? '公開' : '不公開',
                value: row.isVisible,
              }
              // 處理 isCooper 回傳的字串為 "True"
              row.isCooper =
                row.isCooper.toLocaleLowerCase() == true.toString() ? true : false
            })
            this.$store.state.quesData = res.data.rows
            break
          case '01':
            throw res.data.error
          default:
            throw new Error('不合法的回傳代碼')
            break
        }
      } catch (err) {
        alert('[Error]' + err.toString())
      }
    },
    dateRangeOnChange() {
      window.console.log(this.dateRangeText)
    },
    swapDate() {
      let tmp = this.dates[0]
      this.dates[0] = this.dates[1]
      this.dates[1] = tmp
    },
    swapDateQuery() {
      let tmp = this.datesQuery[0]
      this.datesQuery[0] = this.datesQuery[1]
      this.datesQuery[1] = tmp
    },
    getDateRang() {
      this.dateRangeTextInput = this.dateRangeText
    },
    getDateRangQuery() {
      this.dateRangeTextInputQuery = this.dateRangeTextQuery
    },
    textInputDate() {
      const str = this.dateRangeTextInput.replace(/\s/g, '')
      this.dates = str.split('~')
    },
    textInputDateQuery() {
      const str = this.dateRangeTextInputQuery.replace(/\s/g, '')
      this.datesQuery = str.split('~')
    },
    clearTextInput() {
      this.dateRangeTextInput = ''
      this.dateRangeTextInputQuery = ''
    },
    saveDates(dates) {
      //判斷有~連接
      let dateRange = ''
      if (this.dialog) {
        dateRange = this.dateRangeText
      } else {
        dateRange = this.dateRangeTextQuery
      }
      if (dateRange.indexOf('~') != -1) {
        //只能是數字
        const reg = /(\d+)-(\d+)-(\d+)/
        const matched1 = dates[0].match(reg)
        const matched2 = dates[1].match(reg)
        let YYYY = [0, 0]
        let MM = [0, 0]
        let DD = [0, 0]
        if (matched1 && matched2) {
          //字數判定日期格式
          let dateStart = dates[0].split('-')
          let dateEnd = dates[1].split('-')
          let year = [dateStart[0], dateEnd[0]]
          let month = [dateStart[1], dateEnd[1]]
          let date = [dateStart[2], dateEnd[2]]
          for (let i = 0; i < year.length; i++) {
            YYYY[i] = (0 < year[i]) + (year[i] < 10000) //=>2 1~9999年
            MM[i] = (0 < month[i]) + (month[i] < 13) //=>2 1~12月
            DD[i] = 0

            //判斷日期天數
            let dateRangCase = 0
            if (month[i] == 2) {
              if (month[i] % 4 == 0) {
                dateRangCase = 0 //閏年2月 29天
              } else {
                dateRangCase = 1 //非潤2月 28天
              }
            } else {
              if (1 <= month[i] && month[i] <= 7) {
                //1~7月 非2月
                if (month[i] % 2 == 0) {
                  dateRangCase = 2 //30天
                } else {
                  dateRangCase = 3 //31天
                }
              } else {
                // 8~12月
                if (month[i] % 2 == 0) {
                  dateRangCase = 3 //31天
                } else {
                  dateRangCase = 2 //30天
                }
              }
            }
            switch (dateRangCase) {
              case 0:
                DD[i] = (0 < date[i]) + (date[i] < 30) //29天
                break
              case 1:
                DD[i] = (0 < date[i]) + (date[i] < 29) //28天
                break
              case 2:
                DD[i] = (0 < date[i]) + (date[i] < 31) //30天
                break
              case 3:
                DD[i] = (0 < date[i]) + (date[i] < 32) //31天
                break
            }
          }
          let datesConfirm = YYYY[0] + YYYY[1] + MM[0] + MM[1] + DD[0] + DD[1]
          if (datesConfirm == 12) {
            if (this.dialog) {
              this.$refs.dialog.save(dates)
            } else {
              this.$refs.dialogQuery.save(dates)
            }
            window.console.log(dates)
          } else {
            alert('日期格式錯誤!')
          }
        } else {
          alert('請以數字輸入日期!')
        }
      } else {
        alert('請以"~"連接先後日期!')
      }
    },
  },
}
</script>
